import { initData } from '@tma.js/sdk-react'
import { getStorage } from '../storage'
import { isUserLanguage, type UserLanguage } from './languages'

export { DEFAULT_LANGUAGE, isUserLanguage, type UserLanguage } from './languages'

// Runtime language resolution intentionally depends on both Telegram and storage.
/** Telegram sends IETF tags; Uzbek is the only non-Russian app language. */
export function normalizeTelegramLanguage(languageCode?: string): UserLanguage {
	return languageCode?.trim().toLowerCase().split(/[-_]/, 1)[0] === 'uz' ? 'uz' : 'ru'
}

export function resolveInitialLanguage({
	storedLanguage,
	telegramLanguageCode,
}: {
	storedLanguage?: unknown
	telegramLanguageCode?: string
}): UserLanguage {
	return isUserLanguage(storedLanguage)
		? storedLanguage
		: normalizeTelegramLanguage(telegramLanguageCode)
}

export function getInitialLanguage(): UserLanguage {
	const storedLanguage = getStorage('user-preferences')?.language
	let telegramLanguageCode: string | undefined

	try {
		telegramLanguageCode = initData.user()?.language_code
	} catch {
		// Browser-admin sessions do not initialize Telegram SDK state.
	}

	return resolveInitialLanguage({ storedLanguage, telegramLanguageCode })
}
